import { DateUtils } from "./_commons/date-utils";

export class Config {
 
  static CHART_WIDTH_PERCENTAGE: number = 70;
  static RPV_CHART_WIDTH_PERCENTAGE: number = 45;
  static CHART_HEIGHT_PERCENTAGE: number = 50;

  static LVSUBSTATIONBUSBARONETRAFO: string = "LvSubstationBusBarOneTrafo";
  static MVSUBSTATIONBUSBARONETRAFO: string = "MvSubstationBusBarOneTrafo";
  static MVSUBSTATIONBUSBARWITHOUTTRAFO: string = "MvSubstationBusBarWithoutTrafo";
  static MVSTATIONONETRAFO: string = "MvStationOneTrafo";
  static MVSTATIONWITHOUTTRAFO: string = "MvStationWithoutTrafo";
  static MVSTATIONMULTIPLETRAFO: string = "MvStationMultipleTrafo";
  static CCBOX: string = "CustomerConnectionBox";
  static SLEEVE: string = "Sleeve";
  static LVJUNCTIONBOX: string = "LvJunctionBox";
  static GENERATOR: string = "Generator";
  static VOLTAGEREGULATOR: string = "VoltageRegulator";

  // Landau
  // static TOPOLOGY_ID: string = 'LandauTop';
  // static MAP_CENTER_LAT = 48.645401844709305;
  // static MAP_CENTER_LON = 12.703536551915082;

  // tme-lab
  // static TOPOLOGY_ID: string = 'tme-lab';
  // static MAP_CENTER_LAT = 57.013273686254;
  // static MAP_CENTER_LON = 8.7285798823692;

  // TME
  // static TOPOLOGY_ID: string = '0750e25f-2f2e-4fa8-8bd5-d8f344547800';
  // static MAP_CENTER_LAT = 57.013273686254
  // static MAP_CENTER_LON = 8.7285798823692;

  // TME LAB
  // static TOPOLOGY_ID: string = 'tme-lab';
  // static MAP_CENTER_LAT = 57.013273686254;
  // static MAP_CENTER_LON = 8.7285798823692;
  // static MAP_URL = '';

  static MAP_URL = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
  // const MAP_URL = 'https://tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png';

  static CONDITION_COLOR_NORMAL = "#0088CC";
  static CONDITION_COLOR_ATTENTION = "#FF8117";
  static CONDITION_COLOR_PROBLEM = "#FF0000";

  // static SHOW_OGM_BOX: number =  1; //  1 for YES, 0 for NO



  // static normalMaxViolationsRatio: number = 2;
  // static attentionMaxViolationsRatio: number = 10;

  // static  normalMaxViolationsRatioLA: number = 2;
  // static  attentionMaxViolationsRatioLA: number = 10;

  // static rootNodeName: string =  "3011-L"; // 'Trafo';

  // static normalMaxViolationsRatioRPA: number = 2;
  // static attentionMaxViolationsRatioRPA: number = 10;
  // static normalMaxViolationsRatioLACable = 2;
  // static attentionMaxViolationsRatioLACable = 10;

  // static normalMaxViolationsRatioFrequency: number = 10;
  // static attentionMaxViolationsRatioFrequency: number = 25;

  // static rank = 3;

  public static getEpsilonRPV(ymaxReactive: number): number {
    // return  500 - ymaxReactive % 500;
    return 10;
  }

  public static chartLine = {
    dataLabels: {
      enabled: false,
      style: {
        fontWeight: 'normal',
      }
    },
    enableMouseTracking: true
  };

  public static getChartTooltip(unitOfMeasure: string) {
    return {
      enabled: true,
      valueSuffix: " " + unitOfMeasure
    };
  }

 /* public static getChartTooltip1(unitOfMeasure: string, chart: any) {
    return  "<span style=\"font-size: 10px\">"+DateUtils.stringUTCDateToLocalDate(chart.x)+"</span><br/>"
    + "<span style=\"color:" + chart.point.color +";\">● </span>" + chart.series.name + ": " + "<b>" + chart.y  + " " + unitOfMeasure +"</b>";
  }
  */

  public static formatTooltip(chart: any) {
    return  "<span style=\"font-size: 10px\">"+ DateUtils.stringUTCDateToLocalDate2(chart.x) +"</span><br/>"
    + "<span style=\"color:" + chart.point.color +";\">● </span>" + chart.series.name + ": " + "<b>" + chart.y  + " " + chart.series.userOptions.tooltip.valueSuffix +"</b>";
  }

  public static chartYAxisLabelFormatterKilo = {
    formatter: function () {
      return this.value.toFixed(2) + " k";
    }
  };

  public static chartYAxisLabelFormatterPercent = {
    formatter: function () {
      return this.value.toFixed(0) + " %";
    }
  };

  public static chartLegend = {
    layout: 'horizontal',
    align: 'center',
  };

}
